import { AxiosInstance } from "axios";
import { client } from "./api";
import LocationsAdapter from "adapters/LocationsAdapter";

export type LocationCoord = {
  lat: number;
  lng: number;
  timestamp: string;
};

export interface Location {
  coords: LocationCoord[];
  policemanId: string;
  reportId: string;
  _id?: string;
}

export type GetLocationsParams = Pick<Location, "policemanId" | "reportId">;

class LocationsService {
  client: AxiosInstance = client();

  async getLocations({ policemanId, reportId }: GetLocationsParams) {
    const api = client();
    const { data } = await api.get("policemen/locations", {
      params: {
        where: { reportId, policemanId },
      },
    });

    return LocationsAdapter.adapt(data?.items?.[0]?.coords);
  }
}

export default new LocationsService();
